import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import Card from "../../../components/Card";
import SalesChart from "../Dashboard/SalesChart";
import ProductTable from "./ProductTable";
import Modal from "components/Modal/Pawn/BuyProduct/ModalCreate"; // Import Modal component
import "../../../assets/css/Dashbord.css"; // Corrected CSS file name to Dashboard.css
import { GradientButton } from "../../../components/GradientButton";

//Import Icon Mui
import InboxIcon from "@mui/icons-material/Inbox";
import OutboxIcon from "@mui/icons-material/Outbox";
import Store from "@mui/icons-material/Store";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import TrendingUpIcon from "@mui/icons-material/TrendingUp"; // Import TrendingUpIcon
import api from "_api";
import moment from "moment";
import { formatCurrency2Digit } from "utils/helpers/format";

const Dashboard = () => {
  const [dateRange, setDateRange] = useState("day");
  const [isModalOpen, setModalOpen] = useState(false); // State for modal open
  const [companyData, setCompanyData] = useState([]);
  const [allCompanyCount, setAllCompanyCount] = useState([]); // ทั้งหมด , ที่เข้ามาใหม่
  const [allCompanyPackageCount, setAllCompanyPackageCount] = useState([]); //จำนวนร้านค้าทั่วไป รถ ที่ดิน
  const [allAssetCount, setAllAssetCount] = useState([]); //จำนวนสินค้า รถ ที่ดิน

  let revenueDefault = [
    {
      title: "รายได้จากระบบโรงรับจำนำ",
      value: 0,
      icon: <Store />,
      color: "#8F36AA",
    },
    {
      title: "รายได้จากระบบรถ",
      value: 0,
      icon: <DirectionsCarIcon />,
      color: "#DF732C",
    },
    {
      title: "รายได้จากระบบที่ดิน",
      value: 0,
      icon: <HomeWorkIcon />,
      color: "#4696EC",
    },
  ];

  const [revenueData, setRevenueData] = useState(revenueDefault);
  const [marketplaceRevenue, setMarketplaceRevenue] = useState(0);
  const [logsRevenue, setLogsRevenue] = useState(null);

  const handleDateRangeChange = (event) => {
    setDateRange(event.target.value);
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const companyDataHeader = [
    {
      label: "ลำดับ",
    },
    {
      label: "ชื่อบริษัท",
    },
    {
      label: "ประเภทระบบ",
    },
    {
      label: "สถานะ",
    },
    {
      label: "วันที่",
    },
    {
      label: "หมายเลขโทรศัพท์",
    },
  ];

  const fetchRevenueData = async () => {
    await api.super_admin
      .getRevenueSummary()
      .then((res) => {
        const { data } = res;
        setLogsRevenue(data.logs_revenue);
        revenueDefault.map((item) => {
          if (item.title === "รายได้จากระบบทั้งหมด") {
            item.value = data.revenue_all;
          } else if (item.title === "รายได้จากระบบโรงรับจำนำ") {
            item.value = data.revenue_pawns;
          } else if (item.title === "รายได้จากระบบรถ") {
            item.value = data.revenue_cars;
          } else if (item.title === "รายได้จากระบบที่ดิน") {
            item.value = data.revenue_lands;
          }
        });
        setMarketplaceRevenue(data.revenue_marketplace);
        setRevenueData(revenueDefault);
      })
      .catch((error) => {
        console.error("Error fetching revenue data:", error);
      });
  };

  const fetchCompanyWillExpired = async () => {
    const result = await api.super_admin.getCompanyWillExpired();
    if (result?.isStatus) {
      const companyTemp = result?.data.map((item, index) => {
        const {
          Company,
          Package_type: PackageType,
          company_package_id,
          date_expire,
          status,
        } = item;
        let data = {
          id: index + 1,
          company_name: Company?.company_name || "",
          package_type: PackageType?.name_package || "",
          status: status,
          date_expire: moment(date_expire).format("DD/MM/YYYY"),
          phone: Company?.phone || "",
        };
        return data;
      });
      setCompanyData(companyTemp);
    }
  };

  const fetchCountCompanyPackage = async () => {
    const result = await api.super_admin.getReport();

    if (result?.isStatus) {
      const updatedData = result.data.packageTypeCount[0].map((item, index) => {
        let data = {
          title: item.name_package,
          value: item.package_type_usage,
          icon: <OutboxIcon />,
          color: `${result.data.packageTypeCount[0].length - index}`,
        };
        return data;
      });

      const totalCompany = updatedData.reduce(
        (acc, current) => acc + current.value,
        0
      );

      const newCompany = result.data.newCompany[0].reduce(
        (acc, current) => acc + current.total_companies,
        0
      );

      setAllAssetCount([
        {
          title: "จำนวนสินค้า",
          value: result.data.inventoryCount.products_total,
          info: true,
        },
        {
          title: "จำนวนรถ",
          value: result.data.inventoryCount.cars_total,
          info: true,
        },
        {
          title: "จำนวนที่ดิน",
          value: result.data.inventoryCount.lands_total,
          info: true,
        },
      ]);

      const companyTotalData = [
        {
          title: "ร้าน/บริษัททั้งหมด",
          value: totalCompany,
          icon: <Store />,
          color: "1",
        },
        {
          title: "ร้าน/บริษัทที่เข้ามาใหม่",
          value: newCompany,
          icon: <Store />,
          color: "2",
        },
      ];
      setAllCompanyPackageCount(updatedData);
      setAllCompanyCount(companyTotalData);
    }
  };

  useEffect(() => {
    fetchRevenueData();
    fetchCompanyWillExpired();
    fetchCountCompanyPackage();
  }, []);

  console.log(allCompanyCount);

  return (
    <div className="dashboard-container">
      <Typography variant="h4" className="dashboard-title">
        Dashboard
      </Typography>

      <RadioGroup
        row
        className="radio-group"
        value={dateRange}
        onChange={handleDateRangeChange}
      >
        <FormControlLabel value="day" control={<Radio />} label="วันนี้" />
        <FormControlLabel
          value="week"
          control={<Radio />}
          label="สัปดาห์นี้ (อาทิตย์-เสาร์)"
        />
        <FormControlLabel value="month" control={<Radio />} label="เดือนนี้" />
      </RadioGroup>

      <Typography variant="h6" className="dashboard-title">
        รายงานรายได้
      </Typography>
      <Grid
        container
        spacing={2}
        className="chart-container"
        style={{ marginTop: "2px" }}
      >
        <Grid item xs={12} md={6}>
          <Card
            title={"รายได้จากระบบทั้งหมด"}
            value={formatCurrency2Digit(0)}
            icon={<TrendingUpIcon />}
            color={"1"}
            className="card-item"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Card
            title={"รายได้จาก Marketplace"}
            value={formatCurrency2Digit(0)}
            icon={<Store />}
            color={"1"}
            className="card-item"
          />
        </Grid>
        {revenueData.map((metric, index) => (
          <Grid item xs={12} md={4}>
            <Card
              title={metric.title}
              value={formatCurrency2Digit(metric.value)}
              icon={metric.icon}
              color={metric.color}
              className="card-item"
            />
          </Grid>
        ))}
      </Grid>

      <Grid
        container
        spacing={2}
        alignItems="stretch"
        justifyContent="center"
        sx={{
          mt: 1,
        }}
        // style={{ marginTop: "8px", height: "calc(4 * 120px + 3 * 16px)" }} // ความสูงรวม 4 การ์ด
      >
        <Grid
          item
          xs={12}
          md={12}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div
            className="chart-table"
            style={{
              height: "100%",
            }}
          >
            <SalesChart data={logsRevenue} />
          </div>
        </Grid>
      </Grid>

      <Typography
        variant="h6"
        className="dashboard-title"
        sx={{
          marginTop: "20px",
        }}
      >
        รายงานจำนวน
      </Typography>
      <Grid container spacing={2} style={{ marginTop: "6px" }}>
        <Grid item xs={12} md={12} style={{ height: "100%" }}>
          <Grid
            container
            spacing={2}
            style={{ height: "100%", marginBottom: "16px" }}
          >
            {allCompanyCount.map((metric, index) => (
              <Grid item xs={4} key={index}>
                <Card
                  title={metric.title}
                  value={metric.value}
                  icon={metric.icon}
                  color={metric.color}
                  className="card-item"
                />
              </Grid>
            ))}
          </Grid>

          <Grid
            container
            spacing={2}
            style={{ height: "100%", marginBottom: "16px" }}
          >
            {allCompanyPackageCount.map((metric, index) => (
              <Grid item xs={4} key={index}>
                <Card
                  title={metric.title}
                  value={metric.value}
                  icon={metric.icon}
                  color={metric.color}
                  className="card-item"
                />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={2} style={{ height: "100%" }}>
            {allAssetCount.map((metric, index) => (
              <Grid item xs={4} key={index}>
                <Card
                  title={metric.title}
                  value={metric.value}
                  icon={metric.icon}
                  color={metric.color}
                  info={metric.info}
                  className="card-item"
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        className="table-container"
        style={{ marginTop: "20px" }}
      >
        <Grid item xs={12} md={12}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6" className="table-title">
              ร้านบริษัทใกล้หมดอายุ
            </Typography>
          </Grid>
          <ProductTable headers={companyDataHeader} rows={companyData} />
        </Grid>
      </Grid>
      <Modal open={isModalOpen} onClose={handleModalClose} />
    </div>
  );
};

export default Dashboard;
